import { StateCreator } from 'zustand';
import { createAppStore } from '@marriott/mi-store-utils';

interface AccountModelState {
  modelData: Record<string, unknown> | null;
  setModelData: (data: Record<string, unknown>) => void;
  clearModelData: () => void;
  isContentLoading: boolean;
  setIsContentLoading: (loading: boolean) => void;
  activeKey: string | null;
  setActiveKey: (key: string | null) => void;
  signInEmailSuccess?: boolean;
  setSignInEmailSuccess: (success: boolean) => void;
  tokenExpiredFlyout?: boolean;
  setTokenExpiredFlyout: (show: boolean) => void;
  pageErrorReset: boolean;
  setPageErrorReset: (reset: boolean) => void;
}

const initialState: AccountModelState = {
  modelData: null,
  setModelData: () => {},
  clearModelData: () => {},
  isContentLoading: false,
  setIsContentLoading: () => {},
  activeKey: null,
  setActiveKey: () => {},
  signInEmailSuccess: false,
  setSignInEmailSuccess: () => {},
  tokenExpiredFlyout: false,
  setTokenExpiredFlyout: () => {},
  pageErrorReset: false,
  setPageErrorReset: () => {},
};

const accountModelStore: StateCreator<AccountModelState> = set => {
  return {
    ...initialState,
    setModelData: (data: Record<string, unknown>) => {
      set({ modelData: data });
    },
    clearModelData: () => {
      set({ modelData: null });
    },
    setIsContentLoading: (loading: boolean) => {
      set({ isContentLoading: loading });
    },
    setActiveKey: (key: string | null) => {
      set({ activeKey: key });
    },
    setSignInEmailSuccess: (success: boolean) => {
      set({ signInEmailSuccess: success });
    },
    setTokenExpiredFlyout: (show: boolean) => {
      set({ tokenExpiredFlyout: show });
    },
    setPageErrorReset: (reset: boolean) => {
      set({ pageErrorReset: reset });
    },
  };
};

export const useAccountModelStore = createAppStore<AccountModelState>(accountModelStore, { usePersistentStore: false });
